import { base } from 'api';
import {
  SearchUserGroupQueryType,
  UserGroupCreateType,
  UserGroupMemberIdsType,
  UserGroupUpdateType,
} from 'types';

const PATH = '/user-groups';

const getAll = (query: SearchUserGroupQueryType) =>
  base.get(PATH, { params: { ...query } });

const get = (id: number) => base.get(`${PATH}/${id}`);

const getMembers = (id: number, query: SearchUserGroupQueryType) =>
  base.get(`${PATH}/${id}/members`, { params: { ...query } });

const getTargets = (id: number) => base.get(`${PATH}/${id}/targets`);

const post = (data: UserGroupCreateType) => base.post(PATH, data);

const patch = ({ id, ...data }: UserGroupUpdateType) =>
  base.patch(`${PATH}/${id}`, data);

const remove = (id: number) => base.delete(`${PATH}/${id}`);

const addMembers = ({ id, userIds }: UserGroupMemberIdsType) =>
  base.post(`${PATH}/${id}/members`, { userIds });

const removeMembers = ({ id, userIds }: UserGroupMemberIdsType) =>
  base.delete(`${PATH}/${id}/members`, { data: { userIds } });

export {
  getAll,
  get,
  getMembers,
  getTargets,
  post,
  patch,
  remove,
  addMembers,
  removeMembers,
};
